import { pulseButtonStyle } from '@/shared/components/SDComponentsNewDesign/SDButton/styled-components'

export const SDButtonOverrides = (block, isPulse = false) => {
  return {
    BaseButton: {
      style: ({ $theme, $kind }) => ({
        width: block ? '100%' : 'auto',

        borderTopLeftRadius: $theme.borders.radius200,
        borderTopRightRadius: $theme.borders.radius200,
        borderBottomRightRadius: $theme.borders.radius200,
        borderBottomLeftRadius: $theme.borders.radius200,

        fontFamily: $theme.typography.font550.fontFamily,
        fontWeight: $theme.typography.font550.fontWeight,
        ...(isPulse ? pulseButtonStyle($theme, $kind) : {}),
      }),
    },
  }
}
